import React from 'react';

function ChamadoUserField({ value, id = 'chamado-usuario' }) {
    return (
        <div className="chamado-create-field">
            <label htmlFor={id}>Usuário</label>
            <input
                id={id}
                type="text"
                value={value}
                readOnly
                disabled
            />
        </div>
    );
}

export default ChamadoUserField;
